import type { CuratedItem, Image } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
    INTEGRITY_FAIL_MEDIA,
    firstItemOnly,
} from "~utils/moduleIntegrity";

interface SingleStoryAdaptiveHfsWithoutEmbedIntegrityProps {
    items?: CuratedItem[];
    image?: Image;
}

export default function integrityCheck({
    items,
    image,
}: SingleStoryAdaptiveHfsWithoutEmbedIntegrityProps): IntegrityStatus {
    const messages = checkItemArrayIntegrity(firstItemOnly<CuratedItem>(items));

    // This variation needs some form of multimedia to be valid.
    if (!image?.baseUrl && (!items || !items[0]?.image?.baseUrl)) {
        messages.push(INTEGRITY_FAIL_MEDIA);
    }

    return messages;
}
